module.exports = __webpack_public_path__ + "static/media/check_icon.f51fbe2b.svg";